import { render, staticRenderFns } from "./batch.vue?vue&type=template&id=3f2e7bb1"
import script from "./batch.vue?vue&type=script&lang=js"
export * from "./batch.vue?vue&type=script&lang=js"
import style0 from "./batch.vue?vue&type=style&index=0&id=3f2e7bb1&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2e7bb1')) {
      api.createRecord('3f2e7bb1', component.options)
    } else {
      api.reload('3f2e7bb1', component.options)
    }
    module.hot.accept("./batch.vue?vue&type=template&id=3f2e7bb1", function () {
      api.rerender('3f2e7bb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/member/assembly/editVAu/batch.vue"
export default component.exports